import React from 'react';

import { Icon } from '../Icon';

import type { QuickLinkProps, QuickLinksProps } from './QuickLinks.types';

export const QuickLinks = ({
  title,
  lead,
  quickLinks,
  testId,
}: QuickLinksProps): JSX.Element => (
  <div className='account-quicklinks'>
    <div className='account-quicklinks__content'>
      <h3 className='account-quicklinks__heading'>{title}</h3>
      <p className='account-quicklinks__lead text_2'>{lead}</p>
    </div>
    {quickLinks && (
      <ul className='account-quicklinks__link-list'>
        {quickLinks.map((props, index) => (
          <QuickLink {...props} key={index} data-testid={testId} />
        ))}
      </ul>
    )}
  </div>
);

const QuickLink = ({ text, href }: QuickLinkProps): JSX.Element => (
  <li className='account-quicklinks__link-list__item'>
    <a className='account-quicklinks__link button button_secondary' href={href}>
      {text}
      <Icon
        icon='ArrowRightChevron12'
        className='account-quicklinks__icon'
        color='blue'
        size='small'
      />
    </a>
  </li>
);
